import { WarningCard } from 'components/notification-cards';
import { Text } from 'components/Text';
import { getTrans } from 'modules/i18n';
import { isExceedingAllowedDuration } from 'utils/date';
import { useShift } from '../hooks';

export const GeolocationStatusCard = () => {
  const { shift } = useShift();

  if (!shift) {
    return null;
  }

  const {
    isLocationAvailable,
    createdAt,
    reportedShiftEnd,
    metersToLocation,
    geofenceRadius
  } = shift;

  const exceedingShiftSubmissionDelay = !!(
    reportedShiftEnd &&
    createdAt &&
    isExceedingAllowedDuration(
      new Date(reportedShiftEnd),
      new Date(createdAt),
      60 * 60 * 1000
    )
  );

  const isOutOfBounds =
    typeof metersToLocation === 'number' && typeof geofenceRadius === 'number'
      ? metersToLocation > geofenceRadius
      : null;

  return (
    <>
      {isOutOfBounds === false && (
        <WarningCard type="success" sx={{ mt: 2 }}>
          <Text>{getTrans('shiftDetailsPage.location.status.inBounds')}</Text>
        </WarningCard>
      )}
      {exceedingShiftSubmissionDelay && (
        <WarningCard type="warning" sx={{ mt: 2 }}>
          <Text>
            {getTrans(
              'shiftDetailsPage.location.status.exceededShiftSubmissionDelay'
            )}
          </Text>
        </WarningCard>
      )}
      {isOutOfBounds && (
        <WarningCard type="warning" sx={{ mt: 2 }}>
          <Text>
            {getTrans('shiftDetailsPage.location.status.outOfBounds')}
          </Text>
        </WarningCard>
      )}
      {!isLocationAvailable && (
        <WarningCard type="warning" sx={{ mt: 2 }}>
          <Text>
            {getTrans('shiftDetailsPage.location.status.unavailable')}
          </Text>
        </WarningCard>
      )}
    </>
  );
};
